import Vue from "vue";
import VueRouter from "vue-router";
import Roles from "@/router/roles";
import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue";
import Orders from "@/views/Orders.vue";
import Daily from "@/views/Daily.vue";
import Timeseries from "@/views/Timeseries.vue";
import Errors from "@/views/Errors.vue";
import ErrorsV2 from "@/views/ErrorsV2.vue";
import Pipeline from "@/views/Pipeline.vue";
import Unlabelled from "@/views/Unlabelled.vue";
import Uncompleted from "@/views/Uncompleted.vue";
import Profile from "@/views/Profile.vue";
import Unauthorized from "@/views/Unauthorized.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Main,
    children: [
      {
        path: "",
        name: "Home",
        component: Home,
        meta: { authorize: [Roles.Admin, Roles.Viewer, Roles.OrderPipelineViewer, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "orders",
        name: "Orders",
        component: Orders,
        meta: { authorize: [Roles.Admin, Roles.Viewer, Roles.OrderPipelineViewer, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "daily",
        name: "Daily",
        component: Daily,
        meta: { authorize: [Roles.Admin, Roles.Viewer, Roles.OrderPipelineViewer, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "timeseries",
        name: "Timeseries",
        component: Timeseries,
        meta: { authorize: [Roles.Admin, Roles.Viewer, Roles.OrderPipelineViewer, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "errors",
        name: "Errors",
        component: Errors,
        meta: { authorize: [Roles.Admin, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "errors_v2",
        name: "ErrorsV2",
        component: ErrorsV2,
        meta: { authorize: [Roles.Admin, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "pipeline",
        name: "Pipeline",
        component: Pipeline,
        meta: { authorize: [Roles.Admin, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "unlabelled",
        name: "Unlabelled",
        component: Unlabelled,
        meta: { authorize: [Roles.Admin, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "uncompleted",
        name: "Uncompleted",
        component: Uncompleted,
        meta: { authorize: [Roles.Admin, Roles.OrderPipelineAdministrator] },
      },
      {
        path: "profile",
        name: "Profile",
        component: Profile,
        meta: { authorize: [Roles.Admin, Roles.Viewer, Roles.OrderPipelineViewer, Roles.OrderPipelineAdministrator] },
      },
    ],
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
    meta: { authorize: [] },
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  routes,
});

const isAuthorized = (authorize) => {
  if (!authorize.length) {
    return true;
  } else if (
    Vue.prototype.$auth
      .getUserRoles()
      .filter((value) => authorize.includes(value)).length
  ) {
    return true;
  }
  return false;
};

router.beforeEach((to, _, next) => {
  if (!Vue.prototype.$auth.isAuthenticated) return next(false);
  const { authorize = [] } = to.meta;
  return isAuthorized(authorize) ? next() : next({ name: "Unauthorized" });
});

export default router;
